import { useMemoizedFn } from 'ahooks';
import React from 'react';
import { Form, Input, Table } from 'tdesign-react';
import { getMessageById } from '@/services/topicService';
import useTable from '@/hooks/useTable';
import { sleep } from '@/utils/common';
import { columns } from '..';

const { FormItem } = Form;

export default function GetMessageById({ commonProps, searchEvent$ }) {
  const loadData = useMemoizedFn(async (params) => {
    const { data } = await getMessageById({
      ...commonProps,
      ...params,
    });
    setData(data ? [data] : null);
  });

  const { header, config, form, setData, doSearch } = useTable({
    columnController: null,
    onSearch: loadData,
    refresh: null,
    columns,
    search: (
      <>
        <FormItem name='messageId' rules={[{ required: true }]}>
          <Input placeholder='输入消息ID' />
        </FormItem>
      </>
    ),
  });

  searchEvent$.useSubscription(async (messageId) => {
    form.setFields([{ name: 'messageId', value: messageId }]);
    await sleep(50);
    doSearch({ messageId });
  });

  return (
    <>
      {header}
      <Table {...config} />
    </>
  );
}
